/**
 * @author Tanmay <tanmay.pawar@314ecorp.com>
 * @description production configuration
 */

import includes from 'lodash/includes';
import some from 'lodash/some';

import Environment from 'utils/Environment';
import { AUTH_URL_PRODUCTION, DEFAULT_SERVER_URL, getServerUrl, POSTHOG_PRODUCTION_API_HOST_URL } from 'utils/url';
import { EnvConfig } from './config.integration';
import { POSTHOG_EVENTS_TO_BLOCK, URL_BLOCKLIST } from 'utils/postHogUtils';
import { getClientId } from 'utils/util';

const getAPIEndpoint = () => {
	try {
		const domain = window.localStorage.getItem('API_ENDPOINT');
		if (domain) {
			return domain;
		}
		throw new Error('404');
	} catch {
		return Environment.isLocalhost() ? DEFAULT_SERVER_URL : `${window.location.origin}/api/v1`;
	}
};

export const getTenant = (shortForm: boolean = false): string => {
	try {
		const endpoint = getAPIEndpoint();
		if (Environment.isLocalhost()) {
			return 'test11';
		}
		if (endpoint) {
			const firstPart = new URL(endpoint).hostname.split('.')[0];
			return shortForm ? firstPart : `zsegment-${firstPart}`;
		}
		const tenantName = getServerUrl().split('.')[0];
		return shortForm ? tenantName : `zsegment-${tenantName}`;
	} catch {
		return new URL(DEFAULT_SERVER_URL).hostname.split('.')[0];
	}
};

export const getRealm = (): string => {
	try {
		const endpoint = getAPIEndpoint();
		if (Environment.isLocalhost()) {
			return 'test11';
		}
		if (endpoint) {
			const firstPart = new URL(endpoint).hostname.split('.')[0];
			return `${firstPart}`;
		}
		const tenantName = getServerUrl().split('.')[0];
		return `${tenantName}`;
	} catch {
		return `${new URL(DEFAULT_SERVER_URL).hostname.split('.')[0]}`;
	}
};

const config: EnvConfig = {
	appName: 'ZSegment-Web',
	keycloak: {
		config: {
			realm: getRealm(),
			url: AUTH_URL_PRODUCTION,
			clientId: getClientId(),
		},
		initOptions: {
			onLoad: 'login-required',
			token: '',
			enableLogging: true,
			checkLoginIframe: false,
		},
	},
	client: {
		baseURL: getServerUrl(),
		headers: {
			'Content-Type': 'application/json',
		},
	},
	posthog: {
		apiKey: 'phc_EG6diEEPJrXhfTlNY10jFHp7E61wcymSRkxo7WOkarJ',
		config: {
			api_host: POSTHOG_PRODUCTION_API_HOST_URL,
			autocapture: false,
			capture_pageview: false,
			opt_out_capturing_by_default: Environment.isLocalhost(),
			before_send: (cr) => (!includes(POSTHOG_EVENTS_TO_BLOCK, cr?.event) ? cr : null),
			session_recording: {
				recordBody: true,
				maskAllInputs: false,
				maskCapturedNetworkRequestFn: (data) =>
					some(URL_BLOCKLIST, (url) => includes(url, data.name)) ? null : data,
			},
		},
	},
	faro: {
		url: 'https://collector.314ecorp.com/collect',
		apiKey: 'reC!6G!K',
	},
};

export default config;
